export default "__VITE_ASSET__B2O4x3mr__"